var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { ConsentDataResourceScope, ConsentDataSensitivityScope } from "healthex-common/consentscopes.dtos";
import { NOT_LOADED } from "../Infra/RemoteData";
export class PatientConsentDataTypesViewModel extends PatientConsentViewModel {
    get scopesSections() {
        if (this.study === NOT_LOADED || this.study === null) {
            return [];
        }
        const studyScopes = new Set([...this.study.consentDataResourceScopes, ...this.study.consentDataSensitivityScopes]);
        const filterScopes = (scopes) => {
            return scopes.filter((scope) => studyScopes.has(scope));
        };
        const sections = [
            {
                type: "BASIC_DETAILS",
                items: filterScopes([
                    ConsentDataResourceScope.CONTACT_INFO,
                    ConsentDataResourceScope.DEMOGRAPHICS,
                    ConsentDataResourceScope.ADMINISTRATIVE_AND_BILLING,
                ]),
            },
            {
                type: "MEDICAL_HISTORY",
                items: filterScopes([
                    ConsentDataResourceScope.VISITS,
                    ConsentDataResourceScope.DIAGNOSES,
                    ConsentDataResourceScope.TREATMENT_PLAN,
                    ConsentDataResourceScope.MEDICATIONS,
                    ConsentDataResourceScope.ALLERGIES,
                    ConsentDataResourceScope.IMMUNIZATIONS,
                    ConsentDataResourceScope.LABS,
                    ConsentDataResourceScope.IMAGING,
                    ConsentDataResourceScope.DIAGNOSTIC_REPORTS,
                    ConsentDataResourceScope.PROCEDURES,
                    ConsentDataResourceScope.CLINICAL_VITALS,
                    ConsentDataResourceScope.CLINICAL_NOTES,
                ]),
            },
            {
                type: "FAMILY_AND_GENETICS",
                items: filterScopes([
                    ConsentDataResourceScope.GENOMIC_DATA,
                    ConsentDataResourceScope.FAMILY_HISTORY,
                    ConsentDataResourceScope.SOCIAL_HISTORY,
                ]),
            },
            {
                type: "SENSITIVE_INFORMATION",
                items: filterScopes([
                    ConsentDataSensitivityScope.HIV_OR_STI,
                    ConsentDataSensitivityScope.SUBSTANCE_USE_OR_DRUG_ABUSE,
                    ConsentDataSensitivityScope.MENTAL_HEALTH,
                    ConsentDataSensitivityScope.GENETIC_TESTING,
                    ConsentDataSensitivityScope.REPRODUCTIVE_HEALTH_DATA,
                    ConsentDataSensitivityScope.SICKLE_CELL,
                ]),
            },
        ];
        return sections.filter((section) => section.items.length > 0);
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentDataTypesViewModel.prototype, "scopesSections", null);
